import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from './ConfirmDeleteModal.styled';
import { Modal } from '@/components/UI/Modal';
import { useBreakpoint } from '@/hooks/useBreakpoint';
import { Button } from '@/components/UI/Button/Button';

interface ConfirmDeleteModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => void;
  title?: string;
  description?: string | null;
  confirmText?: string;
  cancelText?: string;
}

export const ConfirmDeleteModal = ({
  isOpen,
  title,
  description,
  confirmText,
  cancelText,
  onClose,
  onSubmit,
}: ConfirmDeleteModalProps) => {
  const { t } = useTranslation();
  const { isDesktop } = useBreakpoint();

  const handleClose = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    onClose();
  };

  const handleSubmit = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    onSubmit();
  };

  if (!isOpen) return null;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      maxWidth={isDesktop ? 460 : 345}
      dataTestId="confirm-delete-modal"
    >
      <S.Body>
        <S.Content>
          <S.Title>
            {title || t('bookmark_collections.delete_collection_confirm_title')}
          </S.Title>
          {description !== null && (
            <S.Description>
              {description ||
                t('bookmark_collections.delete_collection_confirm_description')}
            </S.Description>
          )}
        </S.Content>

        <S.ButtonContainer>
          <S.SubmitButton
            isFullWidth
            borderRadius={14}
            onClick={handleSubmit}
            appearance="secondaryOutlined"
            data-testid="confirm-delete-modal-button"
          >
            {confirmText ||
              t('bookmark_collections.delete_collection_confirm_button')}
          </S.SubmitButton>
          <Button
            isFullWidth
            borderRadius={14}
            onClick={handleClose}
            appearance="secondary"
          >
            {cancelText ||
              t('bookmark_collections.delete_collection_confirm_cancel')}
          </Button>
        </S.ButtonContainer>
      </S.Body>
    </Modal>
  );
};
